// extracted by mini-css-extract-plugin
module.exports = {"Screen":"style_Screen__UZYjQ"};